import React from 'react';
import { emptyTranslation } from '@colonist/i18n';
import { Dialog, T } from '@colonist/ui';
import IconMembershipIncentive from '@static/images/icon_membership_incentive.svg';
import styles from './PushReferrersToInviteMoreFriendsDialog.module.scss';
/** Referral push dialog: invite more friends to unlock a free map. */ export function PushReferrersToInviteMoreFriendsDialog({ open, onClose, onClaimMap, remainingReferrals }) {
    const handleClaimMap = ()=>{
        onClaimMap();
        onClose();
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(Dialog.ImageTitle, {
        image: {
            src: IconMembershipIncentive,
            alt: emptyTranslation
        }
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.popups.pushReferrersToInviteMoreFriends.title'
        }
    }))), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("p", {
        className: styles.description
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.popups.pushReferrersToInviteMoreFriends.body',
            options: {
                count: remainingReferrals,
                remainingReferrals: remainingReferrals
            }
        }
    }))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: handleClaimMap
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.popups.pushReferrersToInviteMoreFriends.button'
        }
    }))));
}
